module.exports = __webpack_public_path__ + "img/people.4a738d18.svg";